export type WindowWithDatalayer = {
  dataLayer: {
    push: (args: datalayerObject) => void
  }
}

export type datalayerObject = {
  event?: string
  category: string
  action: string
  label?: string
}

export const acceptCookiesDatalayer = (cookies: string, path: string) =>
  pushDatalayer({
    category: 'Cookies',
    action: cookies,
    label: path
  })

export const acceptAllCookiesDatalayer = (path: string) => acceptCookiesDatalayer('Accept all', path)

export const acceptVideoCookiesDatalayer = (path: string) => acceptCookiesDatalayer('Video', path)

export const acceptTrackingCookiesDatalayer = (path: string) => acceptCookiesDatalayer('Tracking', path)

export const switchLanguageDatalayer = (language: string, path: string) =>
  pushDatalayer({
    category: 'Language switch',
    action: language,
    label: path
  })

export const contactButtonDatalayer = (path: string) =>
  pushDatalayer({
    category: 'Contact - Header',
    action: 'Click button',
    label: path
  })

export const contactFormDatalayer = (subject: string) =>
  pushDatalayer({
    category: 'Contact',
    action: 'Form',
    label: subject
  })

export const pushDatalayer = (d: datalayerObject) => {
  const defaultParams = {
    event: `event.${sitename}`,
    label: window.location.pathname
  }

  const params = { ...defaultParams, ...d }

  window.dataLayer ? window.dataLayer.push(params) : console.log(params)
}
